"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexibleInput = void 0;
const React = require("react");
const nano_theme_1 = require("nano-theme");
const util_1 = require("./util");
const blockClass = (0, nano_theme_1.rule)({
    d: 'inline-block',
    pos: 'relative',
});
const inputClass = (0, nano_theme_1.rule)({
    d: 'inline-block',
    va: 'bottom',
    bxz: 'border-box',
    ov: 'hidden',
    pd: 0,
    mr: 0,
    bd: 0,
    bg: 0,
    out: 0,
    col: 'inherit',
    fw: 'inherit',
    f: 'inherit',
    lh: 'inherit',
    ws: 'pre',
    resize: 'none',
});
const sizerClass = (0, nano_theme_1.rule)({
    d: 'inline-block',
    pos: 'absolute',
    ov: 'hidden',
    pe: 'none',
    us: 'none',
    bxz: 'border-box',
    t: 0,
    l: 0,
    ws: 'pre',
});
const FlexibleInput = ({ inp, value, uncontrolled, multiline, typebefore = '', typeahead = '', extraWidth, minWidth = 8, maxWidth, focus, onChange, onFocus, onBlur, onKeyDown, onSubmit, onCancel, onTab, }) => {
    const inputRef = React.useRef(null);
    const sizerRef = React.useRef(null);
    const theme = (0, nano_theme_1.useTheme)();
    React.useLayoutEffect(() => {
        if (!inputRef.current || !sizerRef.current)
            return;
        if (focus)
            inputRef.current.focus();
        (0, util_1.copyStyles)(inputRef.current, sizerRef.current, [
            'font',
            'fontSize',
            'fontFamily',
            'fontWeight',
            'fontStyle',
            'letterSpacing',
            'textTransform',
            'boxSizing',
        ]);
    }, []);
    React.useLayoutEffect(() => {
        const input = inputRef.current;
        const sizer = sizerRef.current;
        if (!input || !sizer)
            return;
        let width = sizer.scrollWidth;
        if (extraWidth)
            width += extraWidth;
        if (minWidth)
            width = Math.max(width, minWidth);
        if (maxWidth)
            width = Math.min(width, maxWidth);
        const style = input.style;
        style.width = width + 'px';
        if (multiline) {
            const height = sizer.scrollHeight;
            style.height = height + 'px';
        }
    }, [value, typeahead, extraWidth]);
    const attr = {
        ref: (input) => {
            inputRef.current = input;
            if (inp)
                inp(input);
        },
        className: inputClass,
        onChange,
        onFocus,
        onBlur,
        onKeyDown: (e) => {
            if (e.key === 'Enter' && (!multiline || e.ctrlKey)) {
                if (onSubmit)
                    onSubmit(e);
            }
            else if (e.key === 'Escape') {
                if (onCancel)
                    onCancel(e);
            }
            else if (e.key === 'Tab') {
                if (onTab)
                    onTab(e);
            }
            if (onKeyDown)
                onKeyDown(e);
        },
    };
    const input = multiline ? (React.createElement("textarea", Object.assign({}, attr, { value: uncontrolled ? undefined : value }))) : (React.createElement("input", Object.assign({}, attr, { value: uncontrolled ? undefined : value })));
    return (React.createElement(React.Fragment, null,
        !!typebefore && React.createElement("span", { style: { color: theme.g(0.7), verticalAlign: 'top' } }, typebefore),
        React.createElement("span", { className: blockClass },
            input,
            React.createElement("span", { ref: sizerRef, className: sizerClass },
                React.createElement("span", { style: { visibility: 'hidden' } }, value),
                '\u200b',
                !!typeahead && React.createElement("span", { style: { color: theme.g(0.7) } }, typeahead)))));
};
exports.FlexibleInput = FlexibleInput;
//# sourceMappingURL=index.js.map